import { en } from "vuetify/lib/locale";

export default {
  $vuetify: { ...en },
  ...en,
  // Навигация
  navigation: {
    plantsCare: "Plant care technology",
    shop: "Shop",
    collection: "Collection",
  },

  // Хедер
  header: {
    // Статическое меню навигации
    menu: {
      assortment: "Assortiment",
      aboutHappyPlants: "About Happy Plants",
      inspiration: "Inspiration",

      homePage: {
        header: "Home page",
        title: "Home page",
      },
      CollectionPage: {
        header: "Shop All",
        title: "Shop All",
      },
      caringPlants: {
        header: "Caring your plants",
        title: "Plant care principles",
      },
      ourCompany: {
        header: "Our Company & B2B",
        title: "Our Company & B2B",
      },
      santinoSystem: {
        header: "Santino Plant Care System",
        title: "Plant Care System",
      },
      Contact: {
        header: "Contact",
        title: "Contact Us",
      },
      selfWatering: {
        header: "Self watering pots",
        title: "Santino self-watering System",
      },
      sustainability: {
        header: "Sustainability",
        title: "Sustainability",
      },
      blog: {
        header: "Advices & tips for all lovers of plants",
        title: "Read our blog",
      },
      inspireTopics: {
        header: "Inspire by relevant topics",
      },
    },

    // Динамическое меню категорий
    categories: {
      allProducts: "All products",
      loading: "Loading categories...",
      shoppingCart: "Shopping cart",
      goToCart: "Go to my cart",
    },

    // Aria labels для accessibility
    aria: {
      logoLink: "link to home page",
      searchToggle: "Toggle search",
      menuToggle: "Toggle navigation drawer",
    },
  },

  // Мобильное меню (drawer)
  mobileDrawer: {
    // Заголовки окон
    title: {
      main: "main",
    },

    // Основное меню
    menu: {
      home: "home",
      assortment: {
        title: "assortment",
        items: {
          allProducts: "all products",
          shoppingCart: "shopping cart",
        },
      },
      about: {
        title: "about happy plants",
        items: {
          aboutUs: "About us & B2B",
          sustainability: "Sustainability",
          plantCare: "Plant care principles",
          santinoSystem: "Santino self-watering System",
          blog: "Read our blog",
        },
      },
      inspiration: {
        title: "inspiration",
      },
      contact: "contact",
    },

    // Вторичные пункты меню
    secondary: {
      terms: "terms and conditions",
      privacy: "privacy",
    },

    // Футер
    footer: {
      whatsapp: "WHATS APP",
      b2b: "B2B",
      contact: "CONTACT US",
    },
  },

  // Поиск
  searchField: {
    label: "Search products",
    searching: "Searching products...",
    untitledProduct: "Untitled Product",

    // Результаты поиска
    results: {
      title: "Search results ({count})",
      sku: "SKU",
      currency: "EUR",
    },

    // Нет результатов
    noResults: {
      title: "No results found",
      subtitle: 'Try adjusting your search terms for "{query}"',
    },

    // Недавние поиски
    recent: {
      title: "Recent searches",
    },

    // Популярные поиски (примеры)
    popular: {
      selfWatering: "self watering pot",
      indoorPlants: "indoor plants",
      flowerPots: "flower pots",
      plantCare: "plant care",
      decorativePots: "decorative pots",
      outdoorPlanters: "outdoor planters",
    },

    // Ошибка
    error: "Error occurred during search",
  },

  // Корзина покупок
  shoppingCart: {
    ariaLabel: "shopping cart",
    title: "Your cart",
    loading: "Loading products...",
    empty: "Your cart is empty",
    subtotal: "Subtotal:",
    currency: "EUR",
    checkoutNote: "Final price will be seen after checkout",
    placeOrder: "Place order",
    minimumOrder: "min. EUR",
  },

  // Главная страница
  home: {
    subtitle: "For over +16 years we produce",
    headline: {
      part1: "Exceptional flower pots",
      part2: "with self watering system",
      part3: "that cares about your plants",
      part4: "and saves",
      water: "water",
    },
    buttons: {
      plantCare: "Plant care technology",
      shop: "Shop",
    },
    // Секция категорий
    categories: {
      title: "Discover our product range",
      subtitle: "Smart pots for Beautiful Blooms",
      shopAll: "Shop all",
      loading: "Loading categories...",
    },
    // Популярные продукты
    popularProducts: {
      title: "Most popular products",
      subtitle: "Best sellers for Effortless Plant Care",
      seeAll: "See all products",
    },
    // Специальные предложения
    saleOffers: {
      title: "Sale offers",
      subtitle: "Best sellers for Effortless Plant Care",
      seeAll: "See all products",
    },
    // Технология горшков
    potsTechnology: {
      subtitle: "Our pots technology",
      title: {
        part1: "Why",
        plants: "plants",
        part2: "struggle?",
        part3: "how we designed a",
        smarter: "smarter",
        part4: "way to",
        helpThemThrive: "help them thrive",
      },
      buttons: {
        plantCare: "Plant care technology",
        shop: "Shop",
      },
    },
    // Корень проблемы
    rootProblem: {
      title: "What makes your plants sad?",
      paragraph1: {
        part1: "Even the most beautiful",
        highlight:
          "houseplants can struggle when their basic needs aren't met.",
        part2:
          "And more often than not, the problem comes down to one thing - watering.",
      },
      paragraph2:
        "Whether you're a hobbyist or a seasoned plant pro, these challenges can lead to one thing: an unhealthy plant.",
      solutionSubtitle: "Our innovative solution for healthy plants",
      solutionTitle: "That's why we reimagined the flower pot.",
      solutionText:
        "Plants don't thrive on good intentions. They need the right amount of water, delivered at the right time. But remembering who needs what and when? That's where most plant lovers struggle.",
    },
    // Система Santino
    santinoSystem: {
      subtitle: "Santino Plant Care System™",
      title: {
        part1: "At the heart of every Happy Plants flower pot is the",
        systemName: "Santino Plant Care System",
        part2: "— our signature self-watering technology,",
      },
    },
    // Умные растения
    smartPlants: {
      section1: {
        title: "The smart way to grow a happy plants",
        text: {
          part1:
            "No matter who you are a beginner, enthusiast, or plant professional,",
          highlight: "Happy Plants takes the stress out of plant care.",
        },
      },
      section2: {
        title: "The plants are supplied with water on demand",
        text: {
          part1: "With the",
          systemName: "Santino Plant Care System",
          part2:
            "at its core, our self-watering flower pots solve the most common problems, so your plants can thrive and so can you.",
        },
      },
    },
    // Опции/преимущества
    benefits: {
      title:
        "How do the Santino Plant Care System self-watering pots benefit your beloved plants?",
      options: {
        twinPot: {
          title: "Twin Pot",
          subtitle: "Two chambers working in harmony",
          features: {
            doublePot: {
              title: "Double flower pot",
              text: "the mask pot and the planting pot: they make care easier and provide other benefits",
            },
            lessWater: {
              title: "With less water",
              text: "to easily monitor the water level (for non-transparent pots)",
            },
            hecticSchedule: {
              title: "A great solution for a hectic schedule",
              text: "enjoy convenient watering without leaks thanks to the inside water tank",
            },
          },
        },
        healthyRoots: {
          title: "Healthy Roots — Healthy Growth",
          subtitle:
            "A root-first approach that nurtures lasting vitality from the inside out.",
          features: {
            moistureProtection: {
              title: "Moisture excess root protection",
              text: "Twin Pot with the water tank below the roots of the plant contributes to the health of the roots and protects from the stagnation in water",
            },
            airCushion: {
              title: "Protective air cushion",
              text: "the double pot creates an air cushion that provides thermal insulation which excludes the hypothermia of the root system or the drying out of the soil",
            },
            soilAeration: {
              title: "Optimum growth and soil aeration",
              text: "the drainage holes of the inner pot allow air circulation in the soil, thus contributing to the health of the plants",
            },
          },
        },
        aesthetics: {
          title: "Outstanding aesthetics, sublime design",
          subtitle: "A pot that's as beautiful as the plants it supports",
          features: {
            cleanCozy: {
              title: "Clean and cozy",
              text: "the pot and the surfaces remain clean: no spills or traces of dirt",
            },
            visualControl: {
              title: "Visual control window",
              text: "to easily monitor the water level (for non-transparent pots)",
            },
            saucerFree: {
              title: "Saucer-free",
              text: "enjoy convenient watering without leaks thanks to the inside water tank",
            },
          },
        },
        savingWater: {
          title: "Saving water & time",
          subtitle:
            "Thoughtfully engineered to reduce watering frequency — more peace, less guesswork.",
          features: {
            lessFrequent: {
              title: "Plants are watered less frequently",
              text: "The pot and the surfaces remain clean: no spills or traces of dirt",
            },
            innerReservoir1: {
              title: "Inner reservoir",
              text: "the reservoir and drainage holes are inside the pot, below the level of the roots",
            },
            innerReservoir2: {
              title: "Inner reservoir",
              text: "the reservoir and drainage holes are inside the pot, below the level of the roots",
            },
          },
        },
      },
    },
    // Вода - это жизнь
    waterIsLife: {
      title: "Water is life, if used correctly.",
      subtitle: "About our Self-watering technology",
      text: {
        paragraph1: "Every plant has unique needs.",
        paragraph2: "The key is consistency, not guesswork.",
        paragraph3:
          "Plants don't thrive on good intentions — they need the right amount of water, delivered at the right time. But remembering who needs what and when? That's where most plant lovers struggle.",
      },
    },
    // Детали о воде / технологии полива
    waterDetails: {
      section1: {
        title: "We reimagined the flower pot",
        text: "The plants are supplied with water on demand – whenever they need it, in the amount they need.",
      },
      section2: {
        title: "Consistent moisture. No more guesswork.",
        text: 'Our self-watering pots are designed with a built-in water reservoir at the base. They use capillary action also known as "wicking to draw" water upward into the soil as the plant needs it. This natural process ensures that your plant always has access to the right amount of moisture.',
        benefits: {
          noOverwatering: "No more overwatering",
          noUnderwatering: "No more underwatering",
          happyPlants: "Happy plants with less effort",
        },
      },
      section3: {
        title: "About self-watering technology",
        text: "Whether you're a plant novice or a seasoned green thumb, our self-watering system takes the stress out of daily plant care.",
        features: {
          upgrade: {
            title: "The Upgrade",
            text: "Our Self-Watering+ Series takes effortless plant care to the next level. Each pot in this range features either a textile wick system or an innovative Seramis® ceramic drainage cartridge — a high performance material developed in Germany, ensuring your plants receive just the right amount of water.",
          },
          soilMoisture: {
            title: "Optimal soil moisture",
            text: "As plant roots absorb water from the soil, the built-in reservoir beneath them allows the soil to draw up additional moisture as needed — maintaining consistent, optimal humidity for healthy growth.",
          },
        },
      },
    },
    // Магазин воды / самополивающиеся горшки
    shopWater: {
      cards: {
        selfWatering: {
          title: "Self-Watering",
          text: "Whether you're a plant novice or a seasoned green thumb, our self-watering system takes the stress out of daily plant care.",
        },
        selfWateringPlus1: {
          title: "Self-Watering+",
          text: "Twin Pot with wick for optimal soil moisture. Designed for orchid lovers",
        },
        selfWateringPlus2: {
          title: "Self-Watering+",
          text: "Twin Pot with SERAMIS® plant granules cartridge for high waterand nutrient retention.",
        },
      },
      shopNow: "Shop now",
    },
    // Больше для изучения
    moreExplore: {
      title: "More to Explore",
      subtitle:
        "Join hundreds of professionals worldwide who already trust Happy Plants.",
      cards: {
        shopNew: {
          title: "Shop New Models",
          text: "Discover our latest self-watering planters and modern pot designs created to fit every home, office, and business space.",
          button: "Shop now",
        },
        aboutSystem: {
          title: "About Self-Watering System",
          text: "Our innovative self-watering technology keeps plants perfectly hydrated for a long period.",
          button: "Explore",
        },
        plantsCare: {
          title: "Plants Care System",
          text: "Happy Plants promotes plant health through design: aeration, moisture balance, and proper drainage",
          button: "Explore",
        },
        sustainability: {
          title: "Sustainability",
          text: "All Happy Plants products are made from recyclable materials, helping to reduce plastic waste and support.",
          button: "Explore",
        },
      },
    },
  },

  // Страница коллекций
  collection: {
    // Заголовок и хлебные крошки (ShopByCategory)
    header: {
      title: "Discover our product range",
      titleWithCategory: "Collection",
      subtitle:
        "Each Pot, Uniquely Crafted, Carefully designed, thoughtfully engineered — each one made to help your plants (and you) thrive.",
      breadcrumbs: {
        home: "Home",
        allCollections: "All collections",
      },
    },

    // Фильтры и сортировка (ShopFilters)
    filters: {
      search: "Search",
      appliedFilters: "Applied filters:",
      total: "Total:",
      products: "Products",
      advicesAndTips: "Advices and tips",
      sortBy: "Sort by",
      sortOptions: {
        priceLowHigh: "Price from 0-100",
        priceHighLow: "Price from 100-0",
        nameAZ: "Name A-Z",
        nameZA: "Name Z-A",
      },
      filtersTitle: "Filters",

      // Типы фильтров
      filterTypes: {
        potSize: "Pot Size",
        potType: "Pot Type",
        potShape: "Pot Shape",
        exteriorColor: "Exterior color",
        functionality: "Functionality",
      },

      // Функциональность
      functionality: {
        waterControl: "Water control window",
        bottomPlug: "Bottom plug for draining",
        indoor: "For indoor",
        outdoor: "For outdoor",
        semiTransparent: "Semi-transparent",
        orchids: "For orchids",
        windowBox: "Window box",
      },

      // Статусы
      loading: "Loading products...",
      noResults: "No products found",
      clearFilters: "Clear filters",
      loadMore: "Load More",
      retry: "Retry",
    },

    // Недавно просмотренные (RecentlyViewed)
    recentlyViewed: {
      title: "You recently viewed",
      subtitle: "Recently reviewed assortiment by you.",
    },
  },

  // Страница продукта
  product: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Home",
      allCollections: "All collections",
    },

    // Основная информация
    details: {
      skuNumber: "Nr. SKU",
      readFullDescription: "Read full description",
      potType: "Pot Type",
      potShape: "Pot Shape",
      dimensions: "Dimensions (cm)",
      availableColors: "Available exterior colors",
      addToCart: "Add to cart",

      // Количество
      quantity: {
        label: "Quantity",
      },

      // Сообщения
      messages: {
        addedToCart: "Product added to cart successfully!",
      },

      // Информация о платежах
      payment: {
        title: "Online payments are coming soon.",
        description:
          "However, you can still place an order request through the website. Once your request is submitted, a sales manager will contact you shortly to confirm the details and arrange payment. Learn more in",
        link: "Placing order and delivery",
      },
    },

    // Описание продукта
    description: {
      title: "Product Description",
      dimensionsTitle: "Product dimensions",
      faqTitle: "Your Questions, Answered",

      // FAQ вопросы и ответы
      faq: {
        question1: {
          title: "Isn't it hard to take care of orchids?",
          text: "Not with our self-watering system — it keeps the roots hydrated at the right level without daily watering.",
        },
        question2: {
          title: "Will the pot match my interior?",
          text: "Absolutely — each Arte-Dea pot is designed with clean, elegant lines that complement any space.",
        },
        question3: {
          title: "What if I forget to water it?",
          text: "No worries — the built-in reservoir gives your orchid a steady supply of moisture for days, so your plant stays healthy even if you're busy.",
        },
      },
    },

    // Другие продукты
    otherProducts: {
      title_part_1: "More from the",
      title_part_2: "Collection",
      subtitle:
        "Looking for a matching style? Explore other pieces from the same collection below.",
    },
  },

  // Страница Principles (Принципы ухода за растениями)
  principles: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Home",
      principles: "Plants Care Principles",
    },

    // Заголовок
    header: {
      title: "Plants Care Principles",
      subtitle:
        "Helping Those Who Care for Plants. Gentle guidelines for gardeners and plant lovers.",
    },

    // Для кого наши горшки
    forWhom: {
      title: "For whom Happy Plants pots are?",
      subtitle:
        "Five types of plant lovers and gardeners who flourish with our pots and care",
      types: {
        newParents: "New Plant Parents",
        experienced: "Experienced Gardeners",
        indoor: "Indoor Lifestyle Enthusiasts",
        lovers: "Flower and Plant Lovers",
        gifters: "Gift Shoppers",
      },
    },

    // 7 принципов
    sevenPrinciples: {
      mainTitle: "Santino Principles For Healthy Plants",
      mainSubtitle:
        "Delivering hi-quality plant care products trying new concepts",
      shopButton: "Shop all pots",
      bottomTitle:
        "For implementing all 7 Plant Care Principles we designed exceptional flower pots",

      principles: {
        alive: {
          title: "Plants Are Alive",
          text: 'A plant is a living organism — it grows, breathes, transpires, and requires water, nutrients, light, the right environment, and proper temperature. It also needs repotting, can reproduce, and — like us — can thrive or suffer, feel "happy" or show signs of distress.',
        },
        unique: {
          title: "Every Plant Is Unique",
          text: "Every plant is unique, but each one needs the right conditions for growth and protection. This includes a personalized care routine: watering, fertilizing, treatment, and health monitoring — all according to its own natural rhythm.",
        },
        soil: {
          title: "Use the Right Soil",
          text: "Use a suitable potting medium — appropriate soil, drainage material, tools, and fertilizers tailored to your plant's specific needs.",
        },
        pot: {
          title: "Choose the Right Pot",
          text: "Choose the right pot — size, shape, functionality, and even color can affect a plant's well-being.",
        },
        water: {
          title: "Don't Overwater",
          text: "Most plants dislike excess moisture. Overwatering can cause root rot, especially in non-hydrophytic species. Ensure proper drainage, particularly for outdoor pots, to keep roots healthy.",
        },
        heat: {
          title: "Avoid Heat Stress",
          text: "Plants are vulnerable to heat stress. Extreme temperatures — too hot or too cold — can dehydrate the soil, water, and air around the plant, hindering its growth and development.",
        },
        love: {
          title: "Love Your Plants",
          text: "Admire and love your plants! Give them attention, care, and patience. In return, they'll reward you with beauty, vitality, and a deep sense of joy and accomplishment.",
        },
      },
    },

    // Блок с градиентом
    gradient: {
      selfWatering: {
        title: "Self-watering for consistent moisture",
        text: "Happy Plants pots feature a built-in water reservoir and capillary wicking system that delivers water to the soil as needed. This smart reservoir eliminates guesswork and prevents both over and under-watering",
      },
      healthyRoots: {
        title: "Healthy roots thanks to optimal aeration",
        text: "The twin-pot design creates an air cushion around the root zone. Drainage holes and an inner reservoir protect roots from standing water and rot while ensuring they receive fresh air",
      },
      cleanDesign: {
        title: "Clean, time-saving design that conserves water",
        text: "These pots are saucer-free and have a window for checking the water level, keeping surfaces clean and avoiding water stains.",
      },
    },

    // Призыв к действию
    callToAction: {
      title: "Ready to Make Your Plants Happier?",
      text: "Explore our full range of self-watering Happy Plants Pots and give your green friends the care they deserve.",
      button: "Shop all pots",
    },
  },

  // Страница Plants Care System
  plantsCareSystem: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Home",
      system: "Plants Care System",
    },

    // Заголовок
    header: {
      title: "Plants Care System",
      subtitle: "Smart. Stylish. Made for real life",
    },

    // At the heart section
    heart: {
      title: "At the heart of every Happy Plants flower pot",
      text: "The Santino Plant Care System — is our signature self-watering technology, that brings together all Happy Plants features designed to keep plants healthy and plant lovers happy.",
      button: "Shop Plant care pots",
    },

    // All-in-one section
    allInOne: {
      title: "All-in-one care solution",
      text: "The Santino Plant Care System™ brings together all Happy Plants™ features designed to keep plants healthy and plant lovers happy.",
      button: "Shop now",

      features: {
        feature1: "New Plant Parents",
        feature2:
          "Integrated self-watering system for steady, consistent hydration",
        feature3:
          "Visible water-level indicator—never over- or underwater again",
        feature4: "Enhanced airflow to protect roots and prevent rot",
        feature5: "Low-maintenance design perfect for modern, busy lives",
      },
    },

    // Self-Watering section
    selfWatering: {
      title: "Self-Watering technology as a part of Plant care System",
      subtitle:
        "Whether you're a plant novice or a seasoned green thumb, our self-watering system takes the stress out of daily plant care.",
      button: "Explore Self-Watering",

      upgrade: {
        title: "The Upgrade",
        text: "Our Self-Watering+ Series takes effortless plant care to the next level. Each pot in this range features either a textile wick system or an innovative Seramis® ceramic drainage cartridge — a high performance material developed in Germany, ensuring your plants receive just the right amount of water.",
      },

      moisture: {
        title: "Optimal soil moisture",
        text: "As plant roots absorb water from the soil, the built-in reservoir beneath them allows the soil to draw up additional moisture as needed — maintaining consistent, optimal humidity for healthy growth.",
      },
    },
  },

  // Страница Sustainability (Recycling/CycleBloom)
  sustainability: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Home",
      sustainability: "Sustainability",
    },

    // Заголовок и первый блок
    intro: {
      title: "Every great transformation begins with a simple step",
      paragraph1:
        "At Happy Plants, we believe that every flower pot has a story and that story doesn't have to end when the pot cracks, fades, or is no longer needed.",
      paragraph2:
        "Through CycleBloom, our in-house recycling process, we give used pots a second life transforming yesterday's materials into tomorrow's beautiful, functional designs.",
      paragraph3:
        "It's our way of protecting nature, reducing waste, and building a future where sustain-ability and style grow hand in hand.",
    },

    // Процесс переработки
    process: {
      step1: {
        title: "Collection, Recovery & Sorting by Color",
        text: "We begin by gathering and sorting by color used or damaged flower pots from customers, retailers, from production and partners. These are recovered and prepared for a new life instead of ending up in landfills.",
      },
      step2: {
        title: "Shredding & Crushing",
        text: "Sorted pots are then shredded into small, uniform flakes — up to 10 mm in size. These flakes are ideal for further processing and consistent melting behavior during molding.",
      },
      step3: {
        title: "Bagging & Storage",
        text: "The crushed material is stored in large industrial bags, keeping each color batch clean and organized until it's time for production.",
      },
      step4: {
        title: "Molding into New Pots",
        text: "Using traditional thermoplastic molding machines, we transform the recycled material into brand- new flower pots. No virgin material is added — 100% recycled PP is used.",
      },
    },

    // Результат
    result: {
      title: "The result?",
      paragraph1:
        "A new generation of flower pots: strong, stylish, and sustainable. Each one is made entirely from recycled material and is fully recyclable again.",
      paragraph2:
        "It's more than just a pot — it's part of a circular future where beauty meets responsibility.",
    },
  },

  // Страница Self-Watering System
  selfWateringSystem: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Home",
      selfWatering: "Self-Watering System",
    },

    // Заголовок
    header: {
      title: "Self-Watering System",
      subtitle: "Smart. Stylish. Made for real life",
    },

    // Секция "What is Self-Watering?"
    whatIs: {
      title: "What is Self-Watering?",
      text: "Many plant lovers struggle with this issue: how to provide a constant level of moisture for each green companion. Plants don’t live “on guesswork” — they need a stable amount of water at the right moment. But remembering when and how much water each pot needs can be difficult. That’s why we reimagined the flowerpot: our Happy Plants pot with the Self-Watering system eliminates guesswork and makes care easier.",
      button: "Explore",
    },

    // Секция "All-in-one care solution"
    allInOne: {
      title: "This all-in-one care solution",
      text: 'The key feature of Self-Watering is a built-in water reservoir at the base. Through a wick-like capillary system, water gradually rises to the roots, supplying the plants with moisture "on demand."',
      features: {
        feature1:
          "Consistent moisture without guesswork. The large inner reservoir provides a steady water supply.",
        feature2:
          "Root protection. The twin-wall structure creates an air cushion that prevents root rot and hypothermia.",
        feature3:
          "Fewer waterings. The inner tank keeps the plant hydrated for a long time.",
        feature4:
          "Clean and convenient. The pots don't need saucers and include a small window to check water levels (for opaque models).",
        feature5: "Low-maintenance design perfect for modern, busy lives",
      },
      button: "Shop now",
    },

    // Секция "We reimagined"
    reimagined: {
      title: "We reimagined the flower pot",
      text: "The plants are supplied with water on demand – whenever they need it, in the amount they need.",
    },

    // Секция "Consistent moisture"
    consistentMoisture: {
      title: "Consistent moisture. No more guesswork.",
      text: 'Our self-watering pots are designed with a built-in water reservoir at the base. They use capillary action, also known as “wicking”, to draw water upward into the soil, through the inner pot’s drainage holes, as the plant needs it. This natural process ensures that your plant always has access to the right amount of moisture. The second advantage is the aeration of the soil that benefits the roots and overall health of the plant.',
      benefits: {
        noOverwatering: "No more overwatering",
        noUnderwatering: "No more underwatering",
        happyPlants: "Happy plants with less effort",
      },
    },
  },

  // Страница Hashtag
  hashtag: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Home",
      hashtag: "Hashtag #",
    },

    // Заголовок страницы
    header: {
      description: "Here is all you can find about",
      byHappyPlants: "by HappyPlants",
    },

    // Секция с продуктами
    relevantProducts: {
      title: "Relevant products",
      subtitle: "Explore the products relevant to #",
    },

    // Секция со статьями
    relevantArticles: {
      title: "Relevant articles",
      subtitle: "Explore the articles relevant to #",
    },
  },

  // Страница Contact Us
  contactUs: {
    // Заголовок
    header: {
      title: "Contact",
      subtitle:
        "At HappyPlants, your satisfaction is our priority. If there's anything you need, we're always here to help.",
    },

    // Информационные секции
    sections: {
      headOffice: "Head office",
      phone: "Phone",
      email: "Email",
      companyDetails: "Company details",
    },

    // Форма
    form: {
      firstName: {
        label: "First name",
        placeholder: "Name",
      },
      lastName: {
        label: "Last name",
        placeholder: "Last name",
      },
      email: {
        label: "Your email",
        placeholder: "Email",
      },
      phone: {
        label: "Phone (optional)",
        placeholder: "+373 XX XXX XXX",
      },
      topic: {
        label: "Topic",
        placeholder: "Select one option",
      },
      message: {
        label: "Your message",
        placeholder: "Write your message here",
      },
      submitButton: "Send!",
    },

    // Валидация
    validation: {
      required: "This field is required",
      invalidEmail: "Invalid email address",
    },

    // Сообщения
    messages: {
      success: "Your message has been sent successfully!",
      error: "An error occurred. Please try again.",
    },

    // Дефолтные топики
    defaultTopics: {
      general: "General question",
      partnership: "Partnership",
      pricing: "Pricing",
      other: "Other",
    },
  },

  // Страница Blog
  blog: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Home",
      blog: "Happy Plants Blog",
    },

    // Заголовок
    header: {
      title: "Happy Plants blog",
      subtitle: "Insights, tips, and inspiration for plant lovers",
    },
  },

  // Страница About Us & B2B Cooperation
  aboutB2B: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Home",
      aboutB2B: "About Us & B2B Cooperation",
    },

    // Заголовок
    header: {
      title: "About Us & B2B Cooperation",
      subtitle: "Giving flower pots a new life.",
    },

    // Секция "We are Happy Plants"
    weAre: {
      title: "We are Happy Plants",
      subtitle:
        "a European manufacturer of retail-ready self-watering planters with a proven track record of delivering high-margin, fast-turnover products to major retailers and distributors worldwide.",
    },

    // Секция "Your customers want"
    customersWant: {
      title: "Your customers want more than just flower pots.",
      text: "They want convenience, elegance, and solutions that save time and water — and we make that happen.",
    },

    // Секция "Why work with us"
    whyWorkWithUs: {
      title: "Why work with us",
      features: {
        provenSeller:
          "Proven Seller — Our self-watering planters already perform successfully in the US and EU retail markets, both under our brand and as private label.",
        retailReady:
          "Retail-Ready — Every product comes packaged, barcoded, and ready for your shelves.",
        designThatSells:
          "Design That Sells — Attractive, functional designs drive impulse purchases and repeat sales.",
        cleanConvenient:
          "Clean and convenient. The pots don't need saucers and include a small window to check water levels (for opaque models).",
        highProfitMargins:
          "High Profit Margins — Stackable, space-saving construction means lower shipping & storage costs, boosting your bottom line.",
      },
      button: "Shop now",
    },

    // Секция "Our Edge"
    ourEdge: {
      title: "Our Edge",
      features: {
        fullCycle:
          "Full Cycle Manufacturing — From concept design to final packaging, all in our own factory in Moldova.",
        capacity:
          "Capacity You Can Count On — 150,000 planters per month, consistent quality, and on-time deliveries.",
        designSells:
          "Design That Sells — Attractive, functional designs drive impulse purchases and repeat sales.",
        ecoResponsible:
          "Eco-Responsible — We use both recycled and virgin plastics, meeting sustainability goals without compromising quality.",
        logistics:
          "Logistics Without Headaches — DDP/DDU delivery to the USA in 40 days; established, reliable shipping partners.",
      },
      button: "Shop now",
    },

    // Секция "Products That Fit"
    productsFit: {
      title: "Products That Fit Your Market",
      features: {
        indoorOutdoor: "Indoor & outdoor self-watering planters",
        orchidPots: "Premium orchid pots with water-absorbing wick",
        decorativeOptions: "Models with stands & decorative options",
        multipleOptions:
          "Multiple shapes, sizes, and colors — ready for your private label",
      },
      button: "Shop now",
    },

    // Секция "The Opportunity"
    opportunity: {
      title: "The Opportunity",
      paragraph1:
        'We help retailers increase category turnover and expand the growing "convenience gardening" segment with ready-to-stock, ready-to-sell planters.',
      paragraph2:
        "Whether you're looking to expand your gardening assortment, launch a seasonal promotion, or create an exclusive private-label line — we have the supply, the quality, and the experience to deliver.",
    },

    // Секция контактной формы
    contactForm: {
      title: "Let's discuss your assortment goals.",
      contact: {
        title: "Contact",
      },
      sections: {
        headOffice: "Head office",
        phone: "Phone",
        email: "Email",
      },
      form: {
        firstName: {
          label: "First name",
          placeholder: "Name",
        },
        lastName: {
          label: "Last name",
          placeholder: "Last name",
        },
        email: {
          label: "Your email",
          placeholder: "Email",
        },
        phone: {
          label: "Phone (optional)",
          placeholder: "+373 XX XXX XXX",
        },
        topic: {
          label: "Topic",
          placeholder: "Select one option",
        },
        message: {
          label: "Your message",
          placeholder: "Write your message here",
        },
        submitButton: "Send!",
      },
      validation: {
        required: "This field is required",
        invalidEmail: "Invalid email address",
      },
      messages: {
        success: "Your message has been sent successfully!",
        error: "An error occurred. Please try again.",
      },
      defaultTopics: {
        general: "General question",
        partnership: "Partnership",
        pricing: "Pricing",
        other: "Other",
      },
    },
  },

  // Страница статьи блога
  blogArticle: {
    breadcrumbs: {
      home: "Home",
      blog: "Happy Plants Blog",
    },
    title: "Happy Plants blog",
    subtitle: "Insights, tips, and inspiration for plant lovers",
  },

  // Компонент Explore Hashtags
  exploreHashtags: {
    title: "Explore more Happy Plants Hashtags",
  },

  // Корзина покупок
  shoppingCartPage: {
    title: "Your Shopping cart",
    subtitle:
      "Once we receive your request, our manager will check availability and get in touch with you to confirm the details and finalize your order.",
    emptyCart: "Your cart is empty",
    loading: "Loading your cart...",

    // Детали товара
    volumeSize: "Volume + Size",
    color: "Color",

    // Цены и количество
    quantity: "Quantity",
    pot: "pot",
    pots: "pots",

    // Checkout секция
    checkout: {
      title: "Checkout",
      subtotalProducts: "Subtotal products:",
      volume: "Volume",
      minimumOrder: "Minimum order amount is EUR",
      currently: "currently EUR",
      minimumOrderWarning: "The minimum order amount is",
      termsAgreement:
        'By clicking "Place the order", you confirm that you have read the delivery terms and agree to our Terms & Conditions.',
      placeOrder: "Place the order",
    },

    // Информационное сообщение
    paymentInfo: {
      title: "Online payments are coming soon.",
      text: "However, you can still place an order request through the website. Once your request is submitted, a sales manager will contact you shortly to confirm the details and arrange payment. Learn more in Placing order and delivery.",
    },

    // Подтверждения
    removeConfirm: "Are you sure you want to remove this item from your cart?",
  },

  // Форма чекаута
  checkoutForm: {
    title: "Checkout",
    billingAddress: "Billing address:",
    billingAddressText:
      "Used for payment and invoice purposes. Must match your card or payment method details.",
    shippingAddress: "Shipping address:",
    shippingAddressText:
      "Where your order will be delivered. You can use a different address from billing if needed.",

    emptyCart: "Your cart is empty",

    // Предупреждения
    minimumOrderWarning: "Minimum order amount is EUR",
    currentTotal: "Current total: EUR",

    // Кнопки
    placeOrder: "Place order",
    creatingOrder: "Creating order...",

    // Ошибки
    unexpectedError: "An unexpected error has occurred. Please try again.",

    // Сводка заказа
    orderSummary: {
      title: "Order summary",
      productsTotal: "Products total:",
      items: "Items:",
      item: "item",
      itemsPlural: "items",
      shippingCost: "Shipping cost",
      willBeInformed: "Will be informed after placing",
      orderDetails: "Order details:",
    },

    // Информация об оплате
    paymentInfo: {
      title: "Online payments are coming soon.",
      text: "However, you can still place an order request through the website. Once your request is submitted, a sales manager will contact you shortly to confirm the details and arrange payment. Learn more in Placing order and delivery.",
    },
  },

  // Форма адреса доставки
  deliveryAddressForm: {
    title: "Delivery address",

    // Поля формы
    fields: {
      email: "*Email",
      emailPlaceholder: "Email",
      name: "*Name",
      namePlaceholder: "Name",
      surname: "*Surname",
      surnamePlaceholder: "Surname",
      businessName: "Business name",
      businessNamePlaceholder: "Business name",
      addressLine1: "Address line 1",
      addressLine1Placeholder: "Address line 1",
      addressLine2: "Address line 2",
      addressLine2Placeholder: "Address line 2",
      zipCode: "*ZIP code",
      zipCodePlaceholder: "ZIP code",
      city: "*City",
      cityPlaceholder: "City",
      province: "*Province",
      provincePlaceholder: "Province",
      country: "*Country",
      countryPlaceholder: "Select Country",
      noteToCarrier: "Note to courier",
      noteToCarrierPlaceholder: "Note to courier",
      phoneNumber: "*Phone number",
      phoneNumberPlaceholder: "+40 78 580 4972",
    },

    // Валидация
    validation: {
      emailRequired: "Email is required",
      emailInvalid: "Email must be valid",
      fieldRequired: "Field is required",
      minCharacters: "Minimum 2 characters",
      phoneRequired: "Phone number is required",
      phoneInvalid: "Invalid phone number",
      zipRequired: "ZIP code is required",
      zipInvalid: "Invalid ZIP code",
    },

    // Кнопки и состояния
    save: "Save",
    changeAddress: "Change address",
    loadingCountries: "Loading countries...",
    noCountries: "No countries available",
  },

  // Форма адреса для счета
  invoiceAddressForm: {
    title: "Invoicing address",
    useSameAddress: "Use the same address as for delivery",

    // Используем те же поля что и в deliveryAddressForm
    fields: {
      email: "*Email",
      emailPlaceholder: "Email",
      name: "*Name",
      namePlaceholder: "Name",
      surname: "*Surname",
      surnamePlaceholder: "Surname",
      businessName: "Business name",
      businessNamePlaceholder: "Business name",
      addressLine1: "Address line 1",
      addressLine1Placeholder: "Address line 1",
      addressLine2: "Address line 2",
      addressLine2Placeholder: "Address line 2",
      zipCode: "*ZIP code",
      zipCodePlaceholder: "ZIP code",
      city: "*City",
      cityPlaceholder: "City",
      province: "*Province",
      provincePlaceholder: "Province",
      country: "*Country",
      countryPlaceholder: "Select Country",
      noteToCarrier: "Note to courier",
      noteToCarrierPlaceholder: "Note to courier",
      phoneNumber: "*Phone number",
      phoneNumberPlaceholder: "+40 78 580 4972",
    },

    // Валидация
    validation: {
      emailRequired: "Email is required",
      emailInvalid: "Email must be valid",
      fieldRequired: "Field is required",
      minCharacters: "Minimum 2 characters",
      phoneRequired: "Phone number is required",
      phoneInvalid: "Invalid phone number",
      zipRequired: "ZIP code is required",
      zipInvalid: "Invalid ZIP code",
    },

    // Кнопки
    save: "Save",
    changeAddress: "Change address",
    loadingCountries: "Loading countries...",
    noCountries: "No countries",
  },

  // Подтверждение заказа
  orderConfirmation: {
    thankYou: "Thank you,",
    subtitle: "Your plants will be happier than never before",
    emailSent: "We have sent you the invoice and order information to email",
    here: "here",

    // Детали заказа
    productsTotal: "Products total:",
    items: "Items:",
    itemsCount: "items",
    orderId: "Order ID:",

    // Кнопки
    continueShopping: "Continue Shopping",
    downloadInvoiceButton: "Download Invoice",
  },

  // Список деталей заказа
  orderDetails: {
    title: "Order details:",
    volumeSize: "Volume + Size",
    color: "Color",
    productImage: "Product image",
    product: "Product",
  },

  // Компонент Tips & Ideas
  tipsIdeas: {
    title: "Tips, ideas and inspiration",
    subtitle:
      "Explore smart plant care, sustainable design, and the best ways to make the most of your Happy Plants pots.",
    readNow: "Read now",
    hashtagsTitle: "Hashtags",
    hashtagsText:
      "Use hashtags to instantly find related products, articles, and inspiration. One click connects you to everything that matters.",
  },

  // Футер
  footer: {
    site: "Site",
    shopHappyPlants: "Shop Happy Plants",
    clientServiceTitle: "Client Service",
    menu: {
      home: "Home",
      shop: "Shop",
      sustainability: "Sustainability",
      selfWatering: "Self-watering",
      careSystem: "Care system",
      blog: "Blog",
      about: "About us & B2B",
    },
    clientService: {
      contact: "Contact Us",
      shipping: "Shipping",
      terms: "Terms of placing an order",
      privacy: "Privacy",
      retailer: "Become a retailer",
    },
    legal: {
      terms: "Terms and Conditions",
      imprint: "Imprint",
      cookies: "Cookies",
      privacy: "Privacy Policy",
    },
    copyright: "&copy; Happy Plants™ 2025",
    developedBy: "Web design and development by Amark.pro",
  },

  // Общие тексты
  common: {
    readNow: "Read now",
    readMore: "Read more",
    learnMore: "Learn more",
    buyNow: "Buy now",
    addToCart: "Add to cart",
    shop: "Shop",
    shopNow: "Shop now",
    explore: "Explore",
  },
};
